import { render, staticRenderFns } from "./SelectVmAddress.vue?vue&type=template&id=6fd81aff&"
import script from "./SelectVmAddress.vue?vue&type=script&lang=js&"
export * from "./SelectVmAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports